import React, { useEffect, useRef, useState } from "react";
import styles from "./ProblemSection.module.css";
import { useT } from "../../i18n";

const ProblemSection = () => {
  const t = useT().ownership;
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  // Reveal on scroll; reduced-motion users get it fully visible, no animation.
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setInView(true);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      id="ownership"
      ref={ref}
      className={`${styles.section} ${inView ? styles.inview : ""}`}
    >
      <div className={styles.inner}>
        <div className={styles.grid}>
          <div className={styles.lead}>
            <p className={styles.eyebrow}>{t.eyebrow}</p>
            <h2 className={styles.title}>{t.title}</h2>
            <p className={styles.intro}>{t.intro}</p>
            <a
              href="https://calendar.app.google/4YtwnKduScqcFVjc9"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.cta}
            >
              {t.cta}
            </a>
          </div>

          <div className={styles.right}>
            <p className={styles.rightHeader}>{t.rightHeader}</p>
            <ul className={styles.items}>
              {t.items.map((item, i) => (
                <li
                  key={item.title}
                  className={`${styles.item} ${i === 0 ? styles.itemLead : ""}`}
                >
                  <h3 className={styles.itemTitle}>{item.title}</h3>
                  <p className={styles.itemText}>{item.text}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.closer}>
          <h3 className={styles.closerText}>{t.closerTitle}</h3>
          <p className={styles.closerSub}>
            {t.closerSub}
            <strong>{t.closerStrong}</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
